import React, { useState } from 'react';
import Modal from 'scy/Modal';
import { LightBackground } from 'scy/Background';
import { ThumbnailProductImage } from 'scy/ProductImage';
import { LightHR } from 'scy/HR';
import { TextButton, PrimaryButton } from 'scy/buttons';
import { right, width100 } from 'scy/utils.mod.scss';
import { sansSerifMedium, uppercase } from 'scy/text/styles.mod.scss';
import { H5, SecondarySmallUppercase } from 'scy/text';
import { StackedInput } from 'scy/Input';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';
import styles from './list.mod.scss';

function CartItemEngraving({
  item,
  engraving,
  updateEngraving,
  removeEngraving,
  disabled,
  checkout
}) {
  const [editing, setEditing] = useState(false);

  if (!engraving) return null;

  return (
    <div className={styles.engraving}>
      <LightHR />
      <TextButton
        className={`${right} ${margin.xxs}`}
        onClick={() => setEditing(true)}
      >
        Edit
      </TextButton>
      <div className={margin.top_xs}>
        <span className={sansSerifMedium}>Engraving </span>
        <span>(+${engraving.subtotal.toFixed(2)})</span>
      </div>
      {!!engraving.line_1 && <div>{engraving.line_1}</div>}
      {!!engraving.line_2 && <div>{engraving.line_2}</div>}
      {!!engraving.line_3 && <div>{engraving.line_3}</div>}

      {editing && (
        <EditEngravingModal
          item={item}
          engraving={engraving}
          isOpen={editing}
          close={() => setEditing(false)}
          updateEngraving={updatedLines => {
            return updateEngraving({
              ...engraving,
              ...updatedLines
            }).then(() => setEditing(false));
          }}
          removeEngraving={removeEngraving}
          disabled={disabled}
          checkout={checkout}
        />
      )}
    </div>
  );
}

class EditEngravingModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      line_1: props.engraving.line_1,
      line_2: props.engraving.line_2,
      line_3: props.engraving.line_3
    };
    this.setLine1 = this.setLine.bind(this, 1);
    this.setLine2 = this.setLine.bind(this, 2);
    this.setLine3 = this.setLine.bind(this, 3);
    this.save = this.save.bind(this);
    this.remove = this.remove.bind(this);
  }

  setLine(n, event) {
    this.setState({ [`line_${n}`]: event.target.value });
  }

  save(e) {
    e.preventDefault();
    this.props.updateEngraving({
      line_1: this.state.line_1,
      line_2: this.state.line_2,
      line_3: this.state.line_3
    });
  }

  remove() {
    this.props.removeEngraving(this.props.engraving, {
      checkout: this.props.checkout
    });
  }

  render() {
    const item = this.props.item;

    return (
      <Modal
        isOpen={this.props.isOpen}
        handleClose={() => this.props.close()}
        className={styles.engravingModal}
      >
        <LightBackground className={padding.sm}>
          <div className={margin.bottom_sm}>
            <ThumbnailProductImage product={item} className={margin.sm} />
            <H5 className={uppercase}>Engraving for</H5>
            <H5 className={uppercase}>{item.title}</H5>
            <H5 className={uppercase}>{item.subtitle}</H5>
          </div>

          <form onSubmit={this.save} className={margin.bottom_sm}>
            <div className={margin.bottom_sm}>
              <StackedInput
                type="text"
                value={this.state.line_1}
                onChange={this.setLine1}
                placeholder="Enter text (20 character max per line)"
                maxLength={20}
              />
              <StackedInput
                type="text"
                value={this.state.line_2}
                onChange={this.setLine2}
                maxLength={20}
              />
              <StackedInput
                type="text"
                value={this.state.line_3}
                onChange={this.setLine3}
                maxLength={20}
              />
            </div>
            <PrimaryButton
              type="submit"
              className={width100}
              disabled={this.props.disabled}
            >
              Save
            </PrimaryButton>
          </form>

          <SecondarySmallUppercase tag="div" className={margin.bottom_xs}>
            <TextButton
              noUnderline
              onClick={this.remove}
              disabled={this.props.disabled}
            >
              Remove Engraving
            </TextButton>
          </SecondarySmallUppercase>
        </LightBackground>
      </Modal>
    );
  }
}

export default CartItemEngraving;
